<template>
<div class="d-flex flex-wrap justify-content-between">
    <template v-for="(field, i) in formFields.fields" :key="i">
        <base-input
            v-if="field.data.type === 'text'"
            :class="`col-12 col-md-${field.data.width}`"
            type="text"
            v-model="formFields.fields[i].data.value"
            :name="`field_${field.id}`"
            v-validate="{ required: field.data.required }"
            :placeholder="field.translation.label"
            :error="customError(errors.first(`field_${field.id}`))"
        />
        <date-picker-register
            v-else-if="field.data.type === 'date'"
            :class="`col-12 col-md-${field.data.width}`"
            v-model="formFields.fields[i].data.value"
            @input="e => formFields.fields[i].data.value = e"
            :field="field"
        />
        <div
            v-else-if="field.data.type === 'text-area'"
            :class="`col-12 col-md-${field.data.width}`">
            <text-area-field-form
                :field="field"
                v-model="formFields.fields[i].data.value"
                :name="`field_${field.id}`"
                v-validate="{ required: field.data.required }"
                :placeholder="field.translation.label"
                :class="customError(errors.first(`field_${field.id}`)) ? 'form-control mb-1 invalid-text' : 'form-control mb-3'"
                :error="customError(errors.first(`field_${field.id}`))">
            </text-area-field-form>
            <div class="invalid mb-3" v-if="customError(errors.first(`field_${field.id}`))">
                {{customError(errors.first(`field_${field.id}`))}}
            </div>
        </div>
        <div
            v-else-if="showSelect(field)"
            :class="`col-12 col-md-${field.data.width}`">
            <label :for="field.translation.label"> {{ field.translation.label }}
                <select-field-form
                    :field="field"
                    :id="field.translation.label"
                    v-model="formFields.fields[i].data.value"
                    v-validate="{ required: field.data.required }"
                    :name="`field_${field.id}`"
                    :placeholder="field.translation.label"
                    :class="customError(errors.first(`field_${field.id}`)) ? 'form-control mb-1 invalid-text' : 'form-control mb-3'"
                    :error="customError(errors.first(`field_${field.id}`))"
                />
                <div class="invalid mb-3" v-if="customError(errors.first(`field_${field.id}`))">
                    {{customError(errors.first(`field_${field.id}`))}}
                </div>
            </label>
        </div>
        <base-input
            v-else-if="field.data.type === 'telephone'"
            :class="`col-12 col-md-${field.data.width}`"
            type="text"
            v-model="formFields.fields[i].data.value"
            v-mask="formFields.fields[i].data.value && formFields.fields[i].data.value.length > 13 ? '(##)#####-####' : '(##)####-####'"
            :name="`field_${field.id}`"
            v-validate="{ required: field.data.required }"
            :placeholder="field.translation.label"
            :error="customError(errors.first(`field_${field.id}`))">
        </base-input>
    </template>
</div>
</template>

<script>
import TextAreaFieldForm from './ContentComponents/TextAreaFieldForm';
import SelectFieldForm from './ContentComponents/SelectFieldForm';
import DatePickerRegister from './ContentComponents/DatePickerRegister';

import BaseInput from '../../argon/components/Inputs/BaseInput';

export default {
    emits: ['input', 'update:modelValue'],
    name: 'FormBuilder',

    components: {
        BaseInput,
        TextAreaFieldForm,
        SelectFieldForm,
        DatePickerRegister,
    },

    props: {
        modelValue: Object,
        profile: Boolean,
    },

    watch: {
        validating(val) {
            if (val) {
                this.$validator.validate()
                    .then(async (valid) => {
                        await this.$store.commit('IS_VALID', valid);
                    });
            }
        },
    },

    methods: {
        customError(err) {
            if (err) return this.$t('common.required_field');
            return false;
        },
        showSelect(field) {
            const isSelect = field.data.type === 'select';
            const isCategotySelect = field.name === 'Categorias_dos_alunos';
            const showCategorySelect = isCategotySelect && field.options && !this.profile;
            return (isSelect && !isCategotySelect) || showCategorySelect;
        },
    },

    computed: {
        formFields: {
            get() { return this.modelValue; },
            set(value) { this.$emit('update:modelValue', value); },
        },

        validating() {
            return this.$store.getters.VALIDATING;
        },
    },

};
</script>

<style scoped>
label {
    width: 100%;
    color: #8898aa !important;
    font-size: 1rem;
    line-height: 1.5;
}
.invalid {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #fb6340;
}

.invalid-text {
    border: 1px solid #fb6340
}
</style>
